"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../constant");
class APIHelpers {
    constructor(studioBackendUrl, sdk) {
        this.studioBackendUrl = studioBackendUrl;
        this.sdk = sdk;
    }
    getHeaders() {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem(constant_1.STUDIO_APP_JWT)}`,
        };
    }
    checkRefreshJWT() {
        return __awaiter(this, void 0, void 0, function* () {
            const expiresTime = localStorage.getItem(constant_1.STUDIO_APP_JWT_EXPIRES_TIME);
            if (expiresTime) {
                if (Date.now() - 9000 > parseInt(expiresTime)) {
                    yield this.sdk.fetchSession();
                }
            }
        });
    }
    fetch(path, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(path, options, 'GET');
        });
    }
    patch(path, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(path, options, 'PATCH');
        });
    }
    post(path, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(path, options, 'POST');
        });
    }
    delete(path, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sendRequest(path, options, 'DELETE');
        });
    }
    sendRequest(path, options, method) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.checkRefreshJWT();
            try {
                let url = this.studioBackendUrl + path;
                if (options.query) {
                    const queryString = new URLSearchParams(options.query).toString();
                    url = url + '?' + queryString;
                }
                const requestOptions = Object.assign({ method: method, headers: this.getHeaders() }, options);
                if (options.body) {
                    requestOptions.body = JSON.stringify(options.body);
                }
                const response = yield fetch(url, requestOptions);
                if (response.status !== 200) {
                    //eslint-disable-next-line
                    throw response;
                }
                let result;
                try {
                    result = yield response.text();
                    return JSON.parse(result);
                }
                catch (e) {
                    return result;
                }
            }
            catch (error) {
                let response = error;
                try {
                    response = yield response.text();
                    throw JSON.parse(response);
                }
                catch (e) {
                    throw response;
                }
            }
        });
    }
}
exports.default = APIHelpers;
//# sourceMappingURL=apiHelpers.js.map